import React, { useEffect } from 'react';
import { Order } from '../../../../app/services/api/orderManagementClient';
import useCurrencyCodeConfiguration from '../../../../hooks/configurations/useCurrencyCodeConfiguration';
import { applyRoundAndFormat } from '../../../../utils';
import WeightedPointsMap from '../components/WeightedPointsMap';

interface SalesByMarketProps {
  orders: Order[];
}

const SalesByMarket = ({ orders }: SalesByMarketProps) => {
  const { currencyCode, getCurrencyCodeConfiguration } = useCurrencyCodeConfiguration();

  useEffect(() => {
    getCurrencyCodeConfiguration();
  }, []);

  const heatmapData: { location: { lat: number, lng: number }, weight: number }[] = [
  ];

  const marketTotals: { [market: string]: number } = {};
  orders.forEach(order => {
    marketTotals[order.supplierName] = (marketTotals[order.supplierName] || 0) + (order.totalCost || 0);
  });

  return (
    <div>
      {Object.entries(marketTotals).map(([market, total]) => (
        <div key={market}>{market}: {applyRoundAndFormat(total / 1000, currencyCode)}k</div>
      ))}
      <WeightedPointsMap points={heatmapData} />
    </div>
  );
};

export default SalesByMarket;
